var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.642822 15.7499V2.24993C0.642822 1.90893 0.778281 1.58191 1.0194 1.34078C1.26052 1.09967 1.58754 0.964207 1.92854 0.964207H6.67282C6.96652 0.95565 7.2543 1.04795 7.48824 1.22574C7.72216 1.40353 7.88814 1.65608 7.95854 1.94135L8.35711 3.53564H16.0714C16.4124 3.53564 16.7395 3.67109 16.9805 3.91221C17.2216 4.15334 17.3571 4.48036 17.3571 4.82135V15.7499C17.3571 16.091 17.2216 16.4179 16.9805 16.659C16.7395 16.9002 16.4124 17.0356 16.0714 17.0356H1.92854C1.58754 17.0356 1.26052 16.9002 1.0194 16.659C0.778281 16.4179 0.642822 16.091 0.642822 15.7499Z",
    stroke: "#253F68",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.70c536b2602e97a9042ae3f7212f2820.svg";
export { ForwardRef as ReactComponent };